export default __webpack_public_path__ + "static/media/1432.59dc2958.png";